import styles from './TeaserHighlight.module.scss'
import React from 'react'
import { AreaItem } from '@/types/cms/AreaItem'
import { Link } from '@/components/Link'
import { Image } from '@/components/Image'
import TypeVisualizer from '@/elements/widgets/Teaser/components/TypeVisualizer/TypeVisualizer'

const TeaserHighlight = ({ item, children, options }: { item: AreaItem; children: React.ReactNode; options: any }) => {
  const teaser = item
  if (!teaser) {
    return null
  }

  return (
    <article className={styles.teaser} title={teaser.model.headline ?? teaser.model.title}>
      <Link href={teaser.model.url} target="_self" className={styles.link}>
        <div className={styles.container}>
          <Image
            priority={true}
            image={teaser.model.image}
            alt={teaser.model.image?.filename || teaser.model.title}
            className={styles.image}
          />
          <TypeVisualizer item={teaser} position="top-left" className={styles['type-visualizer']} />
          {children}
        </div>
        {teaser.model.leadtext && !options?.hideLeadText && (
          <div className={styles['lead-text']}>{teaser.model.leadtext}</div>
        )}
      </Link>
    </article>
  )
}

export default TeaserHighlight
